import React, { Component } from 'react';
import { Grid, Card, Image, Input, Button, Form, TextArea } from 'semantic-ui-react';
import Views from './view';
import Add from './add';
import Server from '../../../functions/server'
import $ from "jquery";
import Loading from '../../loading';

class Images extends Component {

  state= {
    data: null,
    load: false,
  }

  componentDidMount() {
    this.getImages();
  }

  componentDidUpdate(props) {
    if (props.partCode != this.props.partCode) {
      this.getImages();
    }
  }

  getImages() {
    let context = this;
    context.setState({
      load: true,
      message: 'Getting Spares Images!!!'
    });
    let data1 = {'partCode': this.props.partCode};
    $.ajax({
      type: 'POST',
      data: data1,
      url: Server() + 'spares/getimage.php',
      success: function(data)
      {
        try {
          data = JSON.parse(data);
          if (data.length >= 1) {
            context.setState({
              load: false,
              data: data
            });
          }
          else {
            context.setState({
              load: false,
              data: [],
            });
          }
        } catch (e) {
          context.setState({
            load: false,
          });

        } finally {
          context.setState({
            load: false,
          });
        }
      },
      error: function(err)
      {
        context.setState({
          load: false,
        });
        alert('Try again!!!!')
      }
    });
  }

  updateData() {
    this.getImages();
  }

  render() {
    let view;
    if (this.state.data == null) {

    }
    else {
      view = this.state.data.map((z) => {
        return (
          <Grid.Column mobile={16} tablet={16} computer={4}>
            <Views partCode={z.partCode} image={z.image} image_name={z.image_name} />
          </Grid.Column>
        )
      })
    }
    let image = (
      <Grid.Column mobile={16} tablet={16} computer={4}>
        <Add updateData={this.updateData.bind(this)} partCode={this.props.partCode} />
      </Grid.Column>
    )
    let loading;
    let { load, message } = this.state;
    if (load) {
      loading = (<Loading load={load} message={message} />)
    }
    return (
      <div style={{padding: '1%'}}>
        <Grid style={{padding: '1%'}}>
          {view}{image}
        </Grid>
        {loading}
      </div>
    );
  }
}

export default Images;
